import clientData from 'utils/client-data'

export default function getSpaceKey() {
  return clientData.spaceKeys?.paypalP2p
}


